/*
 * OrderThresholdProgress — estado del pedido mínimo / envío gratis.
 * Fuente del umbral: <script id="order-threshold-config"> (snippets/order-threshold-config.liquid).
 * Base: cart.total_price (después de descuentos, antes de envío), en subunidades.
 *
 * LIMITACIÓN CONOCIDA DE PLATAFORMA (Shopify Basic): este archivo sólo controla los
 * botones del theme. No es validación del carrito ni del checkout en el servidor.
 */
(function (root) {
  const formatCop = (subunits) => {
    const pesos = Math.max(0, Math.round(Number(subunits || 0) / 100));
    return '$' + String(pesos).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const computeState = (totalSubunits, thresholdSubunits, nearSubunits) => {
    const total = Math.max(0, Number(totalSubunits || 0));
    const threshold = Math.max(0, Number(thresholdSubunits || 0));
    const near = Math.max(0, Number(nearSubunits || 0));
    const remaining = Math.max(0, threshold - total);
    let state = 'ready';
    if (total <= 0) state = 'empty';
    else if (total < threshold - near) state = 'progress';
    else if (total < threshold) state = 'near';
    const percent = threshold > 0 ? Math.min(100, Math.floor((total * 100) / threshold)) : 100;
    return { state, total, remaining, percent, ready: state === 'ready' };
  };

  const messageFor = (templates, result, thresholdSubunits) => {
    const amount = formatCop(result.remaining);
    switch (result.state) {
      case 'empty':
        return templates.empty || `Pedido mínimo y envío gratis desde ${formatCop(thresholdSubunits)}`;
      case 'progress':
        return (templates.progress || 'Te faltan {amount} para completar tu pedido y tener envío gratis.').replace('{amount}', amount);
      case 'near':
        return (templates.near || '¡Ya casi! Te faltan {amount}.').replace('{amount}', amount);
      default:
        return templates.ready || '¡Listo! Tu pedido cumple el mínimo y tiene envío gratis.';
    }
  };

  const api = { formatCop, computeState, messageFor };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }

  const doc = root.document;
  const readConfig = () => {
    try {
      const node = doc.getElementById('order-threshold-config');
      const cfg = node ? JSON.parse(node.textContent) : {};
      return { threshold: Number(cfg.threshold || 0), near: Number(cfg.near || 0) };
    } catch (error) {
      return { threshold: 0, near: 0 };
    }
  };

  let lastState = null;

  const render = (cart) => {
    const cfg = readConfig();
    if (!cart || cfg.threshold <= 0) return null;
    const result = computeState(cart.total_price, cfg.threshold, cfg.near);

    for (const el of doc.querySelectorAll('[data-order-threshold]')) {
      // PDP: previsión «con este producto en tu carrito». Si ya está en el carrito no se suma otra vez.
      const addProduct = Number(el.dataset.addProduct || 0);
      const alreadyIn = addProduct > 0 && (cart.items || []).some((item) => item.product_id === addProduct);
      const add = alreadyIn ? 0 : Number(el.dataset.add || 0);
      const own = add > 0 ? computeState(cart.total_price + add, cfg.threshold, cfg.near) : result;
      const templates = {
        empty: el.dataset.msgEmpty,
        progress: el.dataset.msgProgress,
        near: el.dataset.msgNear,
        ready: el.dataset.msgReady,
      };
      el.dataset.state = own.state;
      const message = el.querySelector('[data-order-threshold-message]');
      if (message) message.textContent = messageFor(templates, own, cfg.threshold);
      const bar = el.querySelector('[data-order-threshold-bar]');
      if (bar) bar.style.width = `${own.percent}%`;
      const track = el.querySelector('[data-order-threshold-track]');
      if (track) track.setAttribute('aria-valuenow', String(own.percent));
      const amount = el.querySelector('[data-order-threshold-amount]');
      if (amount) {
        amount.hidden = own.state === 'empty';
        amount.textContent = `${formatCop(own.total)} de ${formatCop(cfg.threshold)}`;
      }
      const cta = el.querySelector('[data-order-threshold-cta]');
      if (cta) cta.hidden = own.state !== 'empty';
    }

    for (const button of doc.querySelectorAll('[data-threshold-checkout]')) {
      button.disabled = !result.ready;
      button.setAttribute('aria-disabled', result.ready ? 'false' : 'true');
      button.classList.toggle('is-disabled', !result.ready);
    }
    for (const note of doc.querySelectorAll('[data-threshold-checkout-note]')) {
      note.hidden = result.ready;
    }

    if (lastState !== null && lastState !== result.state) {
      doc.dispatchEvent(new CustomEvent('lollipop:threshold-change', { detail: { ...result, previous: lastState } }));
    }
    lastState = result.state;
    return result;
  };

  // Guard en fase de captura: ningún botón de checkout del theme avanza bajo el mínimo,
  // aunque otro script lo haya re-habilitado.
  const blockIfNotReady = (event) => {
    const target = event.type === 'submit' ? event.submitter : event.target;
    const button = target instanceof Element ? target.closest('[data-threshold-checkout]') : null;
    if (!button) return;
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  // /cart: al cambiar la cantidad se reenvía el formulario para recalcular en el servidor.
  let quantityTimer = null;
  const onQuantityInput = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'updates[]') return;
    const form = input.form;
    if (!form) return;
    root.clearTimeout(quantityTimer);
    quantityTimer = root.setTimeout(() => {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }, 700);
  };

  doc.addEventListener('click', blockIfNotReady, true);
  doc.addEventListener('submit', blockIfNotReady, true);
  doc.addEventListener('input', onQuantityInput, true);

  root.LollipopThreshold = { ...api, render, readConfig };
})(typeof window !== 'undefined' ? window : globalThis);
